let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lov3e")).then(() => parcelRequire('c8qIO'));